export default __webpack_public_path__ + "static/media/discover_back.249f2e8f.jpg";